import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import RoutineTaskForm from './RoutineTaskForm.jsx';
import { RoutineTasksAPI } from '../../lib/api';
import { buildPath } from '../../config';

/**
 * "Create routine task" page.  Renders ``RoutineTaskForm`` and
 * redirects back to the list on success.
 */
export default function RoutineTaskCreate() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = (payload) => {
    setSubmitting(true);
    setError(null);
    RoutineTasksAPI.create(payload)
      .then(() => navigate(buildPath.routineTasks()))
      .catch((e) => setError(e))
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <PageHeader
        title="New Routine Task"
        subtitle="Define a recurring schedule. The cron worker will create real tasks from this template each time it fires."
      />
      <RoutineTaskForm
        initial={null}
        submitting={submitting}
        error={error}
        onSubmit={onSubmit}
      />
    </>
  );
}
